import Api from "~/service/Api";

class UiMeet3dActivityLogRepository {
  fetch(query) {
    return Api.get(`/ui-meet-3d/activity-logs`, query);
  }
}

export default UiMeet3dActivityLogRepository;
